import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { DateRangeChip } from '../DateRangeChip/DateRangeChip';
import { useSettingsChipTone } from '../settingsChipTone';
export const GetEffectiveDateChipTID = (parentTestId)=>getTestIds(parentTestId);
export const EffectiveDateChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const { EffectiveDateChipTestIds } = useMemo(()=>GetEffectiveDateChipTID(testId), [
        testId
    ]);
    const tone = useSettingsChipTone();
    return /*#__PURE__*/ _jsx(DateRangeChip, {
        testId: testId,
        predicate: predicate,
        onChange: onChange,
        fieldLabel: t.effectiveDateLabel(),
        tone: tone,
        biNames: {
            toggleOperator: 'drafts_ai_search_chip_toggle_effective_date_operator',
            editGte: 'drafts_ai_search_chip_edit_effective_gte',
            editLte: 'drafts_ai_search_chip_edit_effective_lte',
            apply: 'drafts_ai_search_chip_apply_effective_date',
            remove: 'drafts_ai_search_chip_remove_effective_date'
        },
        popoverTestIds: {
            EditPopover: EffectiveDateChipTestIds.EditPopover(),
            GteField: EffectiveDateChipTestIds.GteField(),
            LteField: EffectiveDateChipTestIds.LteField(),
            ApplyButton: EffectiveDateChipTestIds.ApplyButton(),
            ValidationError: EffectiveDateChipTestIds.ValidationError()
        }
    });
};
